import { render, staticRenderFns } from "./SideMenu.html?vue&type=template&id=34fc4bf2&scoped=true&external"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.scss?vue&type=style&index=0&id=34fc4bf2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc4bf2",
  null
  
)

export default component.exports